import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";

const AuthContext = createContext();
// const base_url = `api/user`;
const base_url = `${process.env.REACT_APP_BASE_URL}api/user`;

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  // const [refferalUser, setRefferalUser] = useState(null);
  const [loading, setLoading] = useState(true);
  // const [refferalLoading, setRefferalLoading] = useState(true);
  const [notifications, setNotifications] = useState([]);
  const [notificationsLoading, setNotificationLoading] = useState(false);
  const [updatingIds, setUpdatingIds] = useState(new Set());

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const token = localStorage.getItem("token");
    // const refferalToken = localStorage.getItem("refferal-token");

    if (!token) {
      setUser(null);
      setLoading(false);
      return;
    }

    /*
     */
    // Issue for loading is here - this should not block portal
    // if (!refferalToken) {
    //   setRefferalUser(null);
    //   setRefferalLoading(false);

    // axiosInstance
    //   .get(`${base_url}/refferal/me`)
    //   .then((res) => setRefferalUser(res.data.user || null))
    //   .catch(() => setRefferalUser(null))
    //   .finally(() => setRefferalLoading(false));
    //   // return;
    // }

    // axios
    //   .get(`${base_url}/me`, { headers: { Authorization: `Bearer ${token}` } })
    //   .then((res) => {
    //     setUser(res.data.user || null);
    //   })
    //   .catch((err) => {
    //     setUser(null);
    //   })
    //   .finally(() => {
    //     setLoading(false);
    //   });

    axiosInstance
      .get(`${base_url}/me`)
      .then((res) => setUser(res.data.user || null))
      .catch(() => setUser(null))
      .finally(() => setLoading(false));
  }, []);

  const handleUpdateFilter = async (radius, last_sold_months, last_purchase_months) => {
    try {
      const res = await axiosInstance.put(`${base_url}/filters`, {
        radius,
        last_sold_months,
        last_purchase_months,
      });

      setUser((prev) => ({
        ...prev,
        radius,
        last_sold_months,
        last_purchase_months,
      }));

      return res.data;
    } catch (error) {
      console.error("Filter update failed:", error);
      return null;
    }
  };

  useEffect(() => {
    const interceptor = axiosInstance.interceptors.response.use(
      (response) => response,
      (error) => {
        if (error.response?.status === 401) {
          const currentPath = location.pathname + location.search;
          localStorage.removeItem("token");
          setUser(null);
          navigate("/login", { state: { from: currentPath } });
        }
        return Promise.reject(error);
      },
    );
    return () => axiosInstance.interceptors.response.eject(interceptor);
  }, [navigate, location]);

  const login = async (email, password) => {
    try {
      const res = await axios.post(`${base_url}/login`, { email, password });
      const { token, user } = res.data;

      localStorage.setItem("token", token);
      setUser(user);

      const from = location.state?.from || "/";

      navigate(from, { replace: true });
      return user;
    } catch (err) {
      console.error("[AUTH DEBUG] Login failed:", err);
      throw err;
    }
  };

  // const refferalLogin = async (email, password) => {
  //   try {
  //     const res = await axiosInstance.post(`/api/referral/login`, { email, password });
  //     const { token, user } = res.data;

  //     localStorage.setItem("refferal-token", token);
  //     setRefferalUser(user);

  //     // const from = location.state?.from || "/";

  //     // navigate(from, { replace: true });
  //     return user;
  //   } catch (err) {
  //     console.error("[AUTH DEBUG] Login failed:", err);
  //     throw err;
  //   }
  // };

  const logout = () => {
    localStorage.removeItem("token");
    setUser(null);
  };

  // const refferalLogout = () => {
  //   localStorage.removeItem("referral-token");
  //   setRefferalUser(null);
  // };

  const fetchNotifications = async () => {
    if (!user?.user_id) return;
    try {
      setNotificationLoading(true);
      const res = await axiosInstance.get(`api/notifications/${user?.user_id}`);

      setNotifications(res.data.notifications.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));
    } catch (err) {
      console.error("Fetch Error:", err);
    } finally {
      setNotificationLoading(false);
    }
  };

  const handleMarkAsRead = async (id) => {
    if (!user?.user_id || !id) return;

    try {
      setUpdatingIds((prev) => new Set(prev).add(id));

      setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, is_read: 1 } : n)));

      await axiosInstance.put(`api/notifications/${user.user_id}/${id}`);
    } catch (err) {
      console.error("Mark as read error:", err);
    } finally {
      setUpdatingIds((prev) => {
        const updated = new Set(prev);
        updated.delete(id);
        return updated;
      });
    }
  };

  const handleDelete = async (id) => {
    if (!user?.user_id || !id) return;

    try {
      setUpdatingIds((prev) => new Set(prev).add(id));

      setNotifications((prev) => prev.filter((n) => n.id !== id));

      await axiosInstance.delete(`api/notifications/${user.user_id}/${id}`);
    } catch (err) {
      console.error("Delete error:", err);
    } finally {
      setUpdatingIds((prev) => {
        const updated = new Set(prev);
        updated.delete(id);
        return updated;
      });
    }
  };

  useEffect(() => {
    if (!user?.user_id) return;

    // STEP 1: Fetch notifications once
    fetchNotifications();

    // STEP 2: Setup SSE
    const url = `${process.env.REACT_APP_BASE_URL}api/notifications/stream/${user.user_id}`;
    // console.log("Connecting to SSE URL:", url);
    const eventSource = new EventSource(url);

    // eventSource.onopen = () => console.log("SSE Connected");
    eventSource.onerror = (err) => {
      console.error("SSE error:", err);
      // Optional: reconnect logic here
    };

    eventSource.addEventListener("new_notification", (event) => {
      //   console.log("SSE Event: new_notification", event.data);
      try {
        const data = JSON.parse(event.data);
        setNotifications((prev) => {
          if (prev.find((n) => n.id === data.id)) {
            // console.log("Notification already exists, skipping:", data.id);
            return prev;
          }
          const updated = [data, ...prev].sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
          //   console.log(
          //     "Updated notifications:",
          //     updated.map((n) => n.id)
          //   );
          return updated;
        });
      } catch (e) {
        console.error("Parse error new_notification:", e);
      }
    });

    eventSource.addEventListener("mark_read", (event) => {
      //   console.log("SSE Event: mark_read", event.data);
      try {
        const { id } = JSON.parse(event.data);
        setNotifications((prev) => prev.map((n) => (n.id === Number(id) ? { ...n, is_read: 1 } : n)));
      } catch (e) {
        console.error("Parse error mark_read:", e);
      }
    });

    eventSource.addEventListener("delete_notification", (event) => {
      //   console.log("SSE Event: delete_notification", event.data);
      try {
        const { id } = JSON.parse(event.data);
        setNotifications((prev) => prev.filter((n) => n.id !== Number(id)));
      } catch (e) {
        console.error("Parse error delete_notification:", e);
      }
    });

    return () => {
      //   console.log("Closing SSE");
      eventSource.close();
    }; // eslint-disable-next-line
  }, [user?.user_id]);

  return (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        login,
        logout,
        loading,
        notifications,
        notificationsLoading,
        updatingIds,
        handleDelete,
        fetchNotifications,
        handleMarkAsRead,
        handleUpdateFilter,
        // refferalUser,
        // setRefferalUser,
        // refferalLogin,
        // refferalLogout,
        // refferalLoading,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
